import { styled } from '@mui/material/styles'
import { Grid2 } from '@mui/material'
import Typography, { TypographyProps } from '@mui/material/Typography'

export const BaseGridOrganizationAndMidasId = styled(Grid2)`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;
`
export const BaseOrganizationMidasId = styled(Typography)`
  line-height: 21px;
  font-size: 12px;
  color: #868196;
`

export const BaseOrganizationMidasIdInline = styled(Typography)<TypographyProps>`
  display: inline;
  font-size: inherit;
  color: #868196;
`

BaseOrganizationMidasIdInline.defaultProps = {
  component: 'span',
}

export const BaseMidasIdLabel = styled(Typography)<TypographyProps>`
  color: inherit;
  font-size: inherit;
`
BaseMidasIdLabel.defaultProps = {
  component: 'span',
}
